// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Jte3d56A-ChNNLzbpqRG3A\\=\\={display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}html[dir=ltr] .t7QS7srNc5U-zYtmDAAQ8A\\=\\={margin-left:16px!important;margin-right:24px!important}html[dir=rtl] .t7QS7srNc5U-zYtmDAAQ8A\\=\\={margin-right:16px!important;margin-left:24px!important}.t7QS7srNc5U-zYtmDAAQ8A\\=\\=:active{opacity:.5}.Jte3d56A-ChNNLzbpqRG3A\\=\\={-ms-flex-negative:0;flex-shrink:0}", ""]);
// Exports
exports.locals = {
	"rightHeaderContainer": "Jte3d56A-ChNNLzbpqRG3A==",
	"userPersona": "t7QS7srNc5U-zYtmDAAQ8A=="
};
module.exports = exports;
